import { i18n } from '../../utils';

export const normalizeRelativesList = (payload: any) => {
  const data = payload?.item?.items;
  return data ? data.map((item: any) => ({
    ...item,
    access: i18n(item.access),
  })) : [];
};
